// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3EYWh","requiredAsterisk":"Info_requiredAsterisk__2jbrq"};